import React from "react";
import {
  apollo_useStyles,
  Option,
} from "../../atom/Apollo_styles";
import {Options} from "../../pages/NOTIFY/NotifyModel";
import {PageUser} from "../../pages/USER/UserModel";
import {
  apollo_users_path,
  apollo_accountgroups_path,
  apollo_accounts_path,
  get_apollo_roles_path,
} from "../../atom/Apollo_links";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import {Controller} from "react-hook-form";
// import {ApolloContext} from "../../atom/Apollo_Context";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Modal from "@material-ui/core/Modal";
import {FormControl, FormLabel, RadioGroup, FormControlLabel, Radio} from "@material-ui/core";
import classNames from "classnames";

const animatedComponents = makeAnimated();

function getModalStyle() {
  const top = 40;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

// 検索タイプ
const SEARCH_TYPE_ALL:string = "all";
const SEARCH_TYPE_ACCOUNT_GROUP:string = "accountgroup";
const SEARCH_TYPE_ACCOUNT:string = "account";
const SEARCH_TYPE_ROLE_ACCOUNT_GROUP:string = "roleAccountgroup";
const SEARCH_TYPE_ROLE:string = "role";
const SEARCH_TYPE:string[] = [
  SEARCH_TYPE_ALL,
  SEARCH_TYPE_ACCOUNT_GROUP,
  SEARCH_TYPE_ACCOUNT,
  SEARCH_TYPE_ROLE_ACCOUNT_GROUP,
  SEARCH_TYPE_ROLE,
];

// エラーメッセージ
const ERROR_MESSGAE = [
  "アカウントグループ情報の取得に失敗しました",
  "アカウント情報の取得に失敗しました",
  "ロール情報の取得に失敗しました",
  "ユーザー情報の取得に失敗しました",
];

/*
    画面名：ユーザー選択モーダル
 */
export default function ApolloNotifyUsers(props: { options: Options, formHooks: any, setUsers: any, setOptions: any }) {

  const classes = apollo_useStyles();
  const {options, formHooks, setUsers, setOptions} = props;
  const {control, setValue} = formHooks;
  const [modalStyle] = React.useState(getModalStyle);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [open, setOpen] = React.useState(false);
  const buttonClass = classNames(classes.button, classes.radioSubmit);
  const [searchType, setSearchType] = React.useState(SEARCH_TYPE_ALL);
  const [accountgroups, setAccountgroups] = React.useState<Option[]>([]);
  const [accounts, setAccounts] = React.useState<Option[]>([]);
  const [roles, setRoles] = React.useState<Option[]>([]);
  const [accountgroupIds, setAccountgroupIds] = React.useState("");
  const [accountIds, setAccountIds] = React.useState("");
  const [roleAccountgroupId, setRoleAccountgroupId] = React.useState(0);
  const [roleIds, setRoleIds] = React.useState("");
  // const {state} = React.useContext(ApolloContext);
  const [disabledAccountGroup, setDisabledAccountGroup] = React.useState(true);
  const [disabledAccount, setDisabledAccount] = React.useState(true);
  const [disabledRoleAccountGroup, setDisabledRoleAccountGroup] = React.useState(true);
  const [disabledRole, setDisabledRole] = React.useState(true);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const handleOpen = () => {

    setSearchType(SEARCH_TYPE_ALL);
    setAccountgroupIds("");
    setAccountIds("");
    setRoleAccountgroupId(0);
    setRoleIds("");

    const urlAccountGroups = apollo_accountgroups_path;
    ApolloAxios.get(urlAccountGroups).then((response) => {
      const newAccountgroups: Option[] = [];
      response.data.result?.map(function (accountgroup: any) {
        const option1: Option = {
          value: accountgroup.accountgroupId,
          label: accountgroup.accountgroupName,
        };
        newAccountgroups.push(option1);
      });
      setAccountgroups(newAccountgroups);
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    const urlAccounts = apollo_accounts_path + "/0";
    ApolloAxios.get(urlAccounts).then((response) => {
      const newAccounts: Option[] = [];
      response.data.result?.map(function (account: any) {
        const option2: Option = {
          value: account.accountId,
          label: account.accountName,
        };
        newAccounts.push(option2);
      });
      setAccounts(newAccounts);
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[1], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  
    const urlRoles = get_apollo_roles_path;
    ApolloAxios.get(urlRoles).then((response) => {
      const newRoles: Option[] = [];
      response.data.result?.map(function (role: any) {
        const option3: Option = {
          value: role.masterId,
          label: role.masterName,
        };
        newRoles.push(option3);
      });
      setRoles(newRoles);
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[2], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    setOpen(true);
  };

  const onChangeOption = (name: string, event: any) => {

    let value = "";
    if (name !== SEARCH_TYPE_ROLE_ACCOUNT_GROUP) {
      if (event) {
        let f = false;
        event?.map(function (opt: Option) {
          if (!f) {
            f = !f;
          } else {
            value += ","
          }
          value += String(opt.value);
        });
      }
    } else {
      value = event.value;
    }

    switch (true) {
      case (name === SEARCH_TYPE_ACCOUNT_GROUP):
        setAccountgroupIds(value);
        break;

      case (name === SEARCH_TYPE_ACCOUNT):
        setAccountIds(value);
        break;

      case (name === SEARCH_TYPE_ROLE_ACCOUNT_GROUP):
        setRoleAccountgroupId(Number(value));
        break;

      case (name === SEARCH_TYPE_ROLE):
        setRoleIds(value);
        break;

      default:
        break;
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  // 検索対象ラジオボタンハンドラ
  const handleChange = (event: any) => {
    setSearchType(event.target.value);
    switch (event.target.value) {
      // 全ユーザー
      case (SEARCH_TYPE_ALL):
        setDisabledAccountGroup(true);
        setDisabledAccount(true);
        setDisabledRoleAccountGroup(true);
        setDisabledRole(true);
        break;
      // 対象アカウントグループ
      case (SEARCH_TYPE_ACCOUNT_GROUP):
        setDisabledAccountGroup(false);
        setDisabledAccount(true);
        setDisabledRoleAccountGroup(true);
        setDisabledRole(true);
        break;
      // 対象アカウント
      case (SEARCH_TYPE_ACCOUNT):
        setDisabledAccountGroup(true);
        setDisabledAccount(false);
        setDisabledRoleAccountGroup(true);
        setDisabledRole(true);
        break;
      // 対象ロール
      case (SEARCH_TYPE_ROLE):
        setDisabledAccountGroup(true);
        setDisabledAccount(true);
        setDisabledRoleAccountGroup(false);
        setDisabledRole(false);
        break;
    }
  };

  const handleClick = (event: any) => {
    event.preventDefault();
    let paramIds = "";
    let paramId = 0;
    setValue("users", []);
    switch (true) {
      case (searchType === SEARCH_TYPE_ALL):
        setValue("users", options.option);
        setUsers(options.option);
        options.selected = options.option;
        handleClose();
        return;

      case (searchType === SEARCH_TYPE_ACCOUNT_GROUP):
        paramIds = accountgroupIds;
        break;

      case (searchType === SEARCH_TYPE_ACCOUNT):
        paramIds = accountIds;
        break;

      case (searchType === SEARCH_TYPE_ROLE):
        paramIds = roleIds;
        paramId = roleAccountgroupId;

        if (paramId === 0) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "対象ロールを選択する場合はアカウントグループの指定が必要です"
            }
          });
          return;
        }

        break;

      default:
        break;
    }

    const url = apollo_users_path + "?search=" + searchType + "&ids=" + paramIds + "&id=" + paramId;
    ApolloAxios.get(url).then((response) => {
      const newOption: Option[] = [];
      if (!response.data.result || response.data.result.length === 0) {
        setValue("users", []);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "条件に一致するユーザーが見つかりませんでした。"
          }
        });
      } else {
        response.data.result?.map(function (user: PageUser) {
          const option: Option = {
            value: user.userId,
            label: user.familyName + " " + user.firstName,
          }
          newOption.push(option);
        });
        setValue("users", newOption);
        setUsers(newOption);

        var optionsTemp:Options = {
          option: [],
          selected: [],
        };
    
        optionsTemp.selected = newOption;
        optionsTemp.option = options.option;
        setOptions(optionsTemp);
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[3], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
    handleClose();
  };

  // 配信ユーザー選択ハンドラ
  const handleSelect = (event: any) => {
    setUsers(event);
    options.selected = event;
  }
  
  return (
    <React.Fragment>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle} className={classes.paper}>
          <React.Fragment>
            <Card className={classes.root} square variant="outlined">
              <CardContent className={classes.flame}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">配信ユーザー選択</FormLabel>
                  <RadioGroup aria-label="searchType" name="searchType" value={searchType} onChange={handleChange}
                              className={classes.radioGroup}>
                    <FormControlLabel value={SEARCH_TYPE_ALL} control={<Radio/>} label="全ユーザー"/>
                    <FormControlLabel value={SEARCH_TYPE_ACCOUNT_GROUP} control={<Radio/>} label="対象アカウントグループ"/>
                    <Controller
                      id="accountgroups"
                      name="accountgroups"
                      control={control}
                      render={() => (
                        <Select
                          className={classes.radioSub}
                          placeholder="アカウントグループ"
                          onChange={(e) => {
                            onChangeOption(SEARCH_TYPE_ACCOUNT_GROUP, e)
                          }}
                          options={accountgroups}
                          isMulti
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isDisabled={disabledAccountGroup}
                        />
                      )}
                    />
                    <FormControlLabel value={SEARCH_TYPE_ACCOUNT} control={<Radio/>} label="対象Apolloアカウント"/>
                    <Controller
                      id="accounts"
                      name="accounts"
                      control={control}
                      render={() => (
                        <Select
                          className={classes.radioSub}
                          placeholder="Apolloアカウント"
                          onChange={(e) => {
                            onChangeOption(SEARCH_TYPE_ACCOUNT, e)
                          }}
                          options={accounts}
                          isMulti
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isDisabled={disabledAccount}
                        />
                      )}
                    />
                    <FormControlLabel value={SEARCH_TYPE_ROLE} control={<Radio/>} label="対象ロール"/>
                    <Controller
                      id="roleAccountgroup"
                      name="roleAccountgroup"
                      control={control}
                      render={() => (
                        <Select
                          className={classes.radioSub}
                          placeholder="アカウントグループ"
                          onChange={(e) => {
                            onChangeOption(SEARCH_TYPE_ROLE_ACCOUNT_GROUP, e)
                          }}

                          options={accountgroups}
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isDisabled={disabledRoleAccountGroup}
                        />
                      )}
                    />
                    <Controller
                      id="roles"
                      name="roles"
                      control={control}
                      render={() => (
                        <Select
                          className={classes.radioSub}
                          placeholder="ロール"
                          onChange={(e) => {
                            onChangeOption(SEARCH_TYPE_ROLE, e)
                          }}
                          options={roles}
                          isMulti
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isDisabled={disabledRole}
                        />
                      )}
                    />
                  </RadioGroup>
                  <Button onClick={handleClick} variant="outlined" color="primary" className={buttonClass}>
                    決定
                  </Button>
                </FormControl>
              <div style={{height:150}}>
              </div>
              </CardContent>
              <CardActions className={classes.cardaction}>
              </CardActions>
            </Card>
          </React.Fragment>
        </div>
      </Modal>
      <CardActions className={classes.cardaction}>
        <Typography variant="subtitle1" gutterBottom component="div">
          配信ユーザー
        </Typography>
        <Button
          color="primary"
          variant="contained"
          onClick={handleOpen}
        >
          ユーザー選択
        </Button>
      </CardActions>
      <Controller
        id="users"
        name="users"
        control={control}
        render={() => (
          <Select
            className={classes.radioSub}
            placeholder="配信ユーザー"
            onChange={(e) => {
              handleSelect(e)
            }}
            options={options.option}
            value={options.selected}
            isMulti
            closeMenuOnSelect={false}
            components={animatedComponents}
          />
        )}
      />

    </React.Fragment>
  );
}
